import classNames from 'classnames'
import React, { HTMLAttributes } from 'react'

import { useCompanyCompassLink } from '../../hooks/useCompanyCompassLink'

type Props = Omit<HTMLAttributes<HTMLInputElement>, 'value' | 'readonly'>

const CompanyCompassLinkInput: React.FC<Props> = ({
  style,
  className,
  ...props
}) => {
  const link = useCompanyCompassLink()

  return (
    <input
      className={classNames('form-control flex-grow-1 text-muted', className)}
      value={link}
      readOnly={true}
      style={{ minWidth: '200px', ...style }}
      {...props}
    />
  )
}

export default CompanyCompassLinkInput
